import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Button from 'yoda-core-components/lib/components/Button';
import { AMR_CART_ITEM_LEVEL_REMOVE } from 'yoda-checkout-components/lib/common/AmrConstants';
import * as showGlobalLoaderAction from 'yoda-checkout-components/lib/actions/ShowGlobalLoaderAction';
import openModelEvent from 'yoda-site-components/lib/actions/AnalyticsAction';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as cartItemsAction from '../../actions/CartItemsAction';

export class RemoveItem extends Component {
    static propTypes = {
        index: PropTypes.number.isRequired,
        orderItems: PropTypes.objectOf(PropTypes.array),
        linkClass: PropTypes.string,
        item: PropTypes.objectOf(PropTypes.object),
        collapseCartItem: PropTypes.objectOf(PropTypes.function),
        linkAutoId: PropTypes.string.isRequired,
        actions: PropTypes.objectOf(PropTypes.function),
    };

    static defaultProps = {
        orderItems: [],
        item: {},
        collapseCartItem: () => {},
        actions: {},
        linkClass: '',
    };

    constructor() {
        super();
        this.removeItem = this.removeItem.bind(this);
    }

    isMoreThanOneOrder = () => this.props.orderItems.length > 1;

    removeHandler = (event) => {
        event.preventDefault();
        const { item, index } = this.props;
        if (this.isMoreThanOneOrder()) {
            this.props.collapseCartItem();
            this.props.actions.removeCartItem({ ...item, index });
        } else {
            this.removeItem();
        }
    };

    removeItem() {
        this.props.actions.showGlobalLoader(true);
        this.props.actions.removeCartItem(this.props.item.id);
    }

    render() {
        return (
            <div
                id={AMR_CART_ITEM_LEVEL_REMOVE}
                className={dt(['m-0', 'p-0'])}
                data-automation-id="at-remove-items-wrapper"
            >
                <Button
                    className={this.props.linkClass}
                    buttonType="Link"
                    size="Md"
                    automationId={this.props.linkAutoId}
                    onClick={this.removeHandler}
                >
                    Remove
                </Button>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    orderItems: state.orderItems,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        { ...cartItemsAction, ...showGlobalLoaderAction, ...openModelEvent },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(RemoveItem);
